import * as React from "react";

import { FeatureController } from "../features-provider";

import { InitialStateMinimumRequirements_OneTimePassword_Feature } from "./one-time-password-intitial-state";

export enum OneTimePasswordFeatures {
  OneTimePassword = "one_time_password",
}

interface UseOneTimePasswordFeatureControllerProps {
  initialState: InitialStateMinimumRequirements_OneTimePassword_Feature;
}

export const useOneTimePasswordFeatureController = (
  props: UseOneTimePasswordFeatureControllerProps
) => {
  const { initialState } = props;
  const { one_time_password } = initialState || {};
  const { enabled: one_time_password_enabled } = one_time_password || {};

  const read: FeatureController["read"] = React.useCallback(() => {
    return [
      {
        name: OneTimePasswordFeatures.OneTimePassword,
        enabled: one_time_password_enabled,
      },
    ];
  }, [one_time_password_enabled]);

  const value: FeatureController = React.useMemo(
    () => ({
      name: OneTimePasswordFeatures.OneTimePassword,
      read,
    }),
    [read]
  );
  return value;
};
